import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const specialties = [
  {
    title: "Excellence",
    description:
      "We are a vibrant Firm of Chartered Accountants with the objective of creating a single window for the entire array of financial services.",
    icon: "images/icons/low-price-3.svg",
  },
  {
    title: "Integrity",
    description:
      "We believe integrity is the quintessential value that is the engine behind getting things done in the organization.",
    icon: "/images/icons/clock-3.svg",
  },
  {
    title: "Independence",
    description:
      "Professional integrity and independence is an essential characteristic of all the professions but is more so in the case of accountancy profession.",
    icon: "images/icons/order-tracking-1.svg",
  },
  {
    title: "24/7 Support",
    description:
      "We Provide 24/7 Quick Support Regarding Indirect Taxation regarding DGFT Services, Customs Services and GST, as well as Industrial Subsidies from various Government Departments.",
    icon: "/images/icons/suport-3.svg",
  },
];

// Variants
const headingVariant = {
  hidden: { opacity: 0, y: -30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.8,
      ease: "easeOut",
    },
  }),
};

const OurSpecialties = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        {/* Section Heading */}
        <motion.div
          className="mb-12"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="text-green-600 font-semibold uppercase tracking-widest text-sm mb-2">
            ~ Why Choose Us ~
          </p>
          <h2 className="text-4xl font-bold text-gray-900 leading-tight">
            Why <span className="text-green-600">Environature Solution</span>
          </h2>
        </motion.div>

        {/* Feature Cards */}
        <Link to="/" className="block">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
            {specialties.map((item, index) => (
              <motion.div
                key={index}
                className="relative overflow-hidden group bg-white border border-gray-200 rounded-2xl p-6 shadow hover:shadow-xl transition duration-300"
                custom={index}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
              >
                {/* Background image (hidden by default, shown on hover) */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500 bg-cover bg-center z-0"
                  style={{ backgroundImage: `url(https://images.unsplash.com/photo-1542281286-9e0a16bb7366?fit=crop&w=800)` }}
                ></div>

                {/* Content over background */}
                <div className="relative z-10">
                  {/* Icon with hover scale */}
                  <motion.div whileHover={{ scale: 1.1 }} className="flex justify-center mb-4">
                    <img src={item.icon} alt={item.title} className="h-16 w-16 transition-transform duration-300" />
                  </motion.div>

                  <h4 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h4>
                  <p className="text-base text-gray-800 leading-relaxed">{item.description}</p>
                </div>
              </motion.div>

            ))}
          </div>
        </Link>
      </div>
    </section>
  );
};

export default OurSpecialties;
